<template>
<div class='fw-simple-card-wrapper'
     :class='{
         "fw-simple-card-wrapper--disabled": isDisabled,
         "fw-simple-card-wrapper--active": isActive,
     }'
     :style='wrapperStyles'>
    <slot name='default'></slot>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class FwSimpleCard extends Vue {
    @Prop({ type: String, default: '150px' }) readonly height!: string;
    @Prop({ type: String, default: 'auto' }) readonly width!: string;
    @Prop({ type: String, default: '10px' }) readonly borderRadius!: string;
    @Prop({ type: String, default: '0 45px' }) readonly padding!: string;
    @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isDisabled!: boolean;

    get wrapperStyles(): { [key: string]: string } {
        return {
            'height': this.height,
            'width': this.width,
            'padding': this.padding,
            'borderRadius': this.borderRadius,
        };
    }
}
</script>

<style lang='sass'>
.fw-simple-card-wrapper
    box-shadow: $big-box-shadow
    background-color: #FFFFFF
    display: flex
    align-items: center
    justify-content: center
    transition: box-shadow 0.5s
    will-change: box-shadow

    &--active:not(&--disabled)
        cursor: pointer
        &:hover
            box-shadow: none

    &--disabled
        opacity: 0.5
        cursor: default
        box-shadow: none
</style>
